import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, CupSodaIcon, Loader2Icon, ArrowRightIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { Button } from '../components/ui/Button';
import { SmartImage } from '../components/common/SmartImage';
import { useI18n } from '../lib/i18n';
import { IMAGES } from '../lib/images';
import { MACHINE, DRINKS } from '../lib/data';
export function Verify() {
  const {
    t,
    lang
  } = useI18n();
  const navigate = useNavigate();
  const {
    machineId
  } = useParams();
  const [verifying, setVerifying] = useState(true);
  const available = DRINKS.filter(d => d.inStock).length;
  useEffect(() => {
    const timer = setTimeout(() => setVerifying(false), 1600);
    return () => clearTimeout(timer);
  }, []);
  return <PageShell data-id="element-506" data-mp="2218riaszh23a">
      <section className="mx-auto flex min-h-[70vh] max-w-lg items-center px-4 py-12 sm:px-6" data-id="element-507" data-mp="221scy1hue8m2">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="glass-card w-full overflow-hidden p-0" data-id="element-508" data-mp="2zzmnolzw4qk">
          <SmartImage src={IMAGES.machinePhoto} alt="RevoV vending machine" className="h-52 w-full object-cover" data-id="element-509" data-mp="7x9etc0rqui3" />
          <div className="p-6 text-center" data-id="element-510" data-mp="hodqa1r8jx86">
            {verifying ? <div className="flex flex-col items-center py-6" data-id="element-511" data-mp="hq6wxh1umhg6">
                <Loader2Icon className="h-10 w-10 animate-spin text-neon" data-id="element-512" data-mp="vn3mzga57uw0" />
                <p className="mt-4 text-lg font-medium text-white" data-id="element-513" data-mp="qo93sd89k4bd">
                  {t('verifying')}
                </p>
              </div> : <>
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[rgba(74,222,128,0.12)]" data-id="element-514" data-mp="2sg5k005dm2ch">
                  <CheckCircle2Icon className="h-9 w-9 text-[#4ADE80]" data-id="element-515" data-mp="wdsm7psaz9q3" />
                </div>
                <h1 className="mt-4 text-2xl font-bold text-white" data-id="element-516" data-mp="11cvhiiihe1kv">
                  {t('machine_ready')}
                </h1>
                <p className="mt-2 text-silver/80" data-id="element-517" data-mp="15bw0c10yl47v">
                  <span className="font-semibold text-white" data-id="element-518" data-mp="1ad1rhuez0jfa">
                    {machineId ?? MACHINE.id}
                  </span>{' '}
                  {t('ready_to_serve')}
                </p>

                <div className="mt-6 space-y-2 rounded-lg border border-[rgba(217,217,217,0.12)] bg-[rgba(217,217,217,0.04)] p-4 text-left text-sm text-silver/80" data-id="element-519" data-mp="1ka6f7yogsmy7">
                  <p className="flex items-center gap-2" data-id="element-520" data-mp="1p3j0pzxukdmq">
                    <CupSodaIcon className="h-4 w-4 text-neon" data-id="element-521" data-mp="1t1ypa89ktu29" />
                    {available} {t('drinks_available_n')}
                  </p>
                  <p className="flex items-center gap-2" data-id="element-522" data-mp="1y09uu6su9ieo">
                    <MapPinIcon className="h-4 w-4 text-neon" data-id="element-523" data-mp="231z8zvbcyc6z" />
                    {lang === 'en' ? MACHINE.location_en : MACHINE.location_am}
                  </p>
                </div>

                <div className="mt-6" data-id="element-524" data-mp="28502mtaxbgqt">
                  <Button pulse fullWidth onClick={() => navigate('/select/' + (machineId ?? MACHINE.id))} data-id="element-525" data-mp="2884dg9iw9aqg">
                    {t('continue')}
                    <ArrowRightIcon className="h-4 w-4" data-id="element-526" data-mp="2vuautme7k2tc" />
                  </Button>
                </div>
              </>}
          </div>
        </motion.div>
      </section>
    </PageShell>;
}